<template>
  <div>
    <!--  包裹搜索表单-->
    <el-dialog :title="$t('message.packageSearchForm')" :close-on-click-modal="false"
      :visible.sync="$parent.parcelSearchFormDialogVisible" width="1462px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!--编号  -->
            <li class="flex05">NO</li>
            <!--订单号  -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--番号  -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--图片  -->
            <li>{{ $t("message.picture") }}</li>

            <!--规格  -->
            <li class="flex15">{{ $t("message.specification") }}</li>
            <!--数量  -->
            <li class="flex05">{{ $t("message.number") }}</li>
            <!--交易号  -->
            <li class="flex15">{{ $t("message.transactionNumber") }}</li>
            <!--物流号  -->
            <li class="flex15">{{ $t("message.logisticsNumber") }}</li>
            <!--操作员  -->
            <li>{{ $t("message.operator") }}</li>
          </ol>
          <ul v-for="(item, index) in parcelSearchForm" :key="index">
            <!--编号  -->
            <li class="flex05">{{ index + 1 }}</li>
            <!--订单号  -->
            <li class="flex15">
              <div class="template">
                <p>{{ item.order_sn }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>
            <!--番号  -->
            <li class="flex05">{{ item.sorting }}</li>
            <!--照片  -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference" @click="openUrl(item)">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!--规格  -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--数量  -->
            <li class="flex05">{{ item.possible_num }}</li>
            <!--交易号  -->
            <li class="flex15">{{ item.purchase_no }}</li>
            <!--物流号  -->
            <li class="flex15">
              <div class="attribute">
                <p v-for="(item, index) in item.express_no" :key="index">
                  {{ index + 1 }}:{{ item }}
                </p>
              </div>
            </li>
            <!--操作员  -->
            <li>
              <div class="attribute">
                <p>{{ $t("message.business") }}:{{ item.y_name }}</p>
                <p>{{ $t("message.purchase") }}:{{ item.g_name }}</p>
                <p>{{ $t("message.distribution") }}:{{ item.p_name }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    parcelSearchForm: { type: Array },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.parcelSearchForm);
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  ul {
    padding: 24px 0;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex05 {
    flex: 0.5;
  }

  .template {
    text-align: center;
  }

  p {
    margin-bottom: 5px;
  }
}
</style>